import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import {
    DoseStatisticsRow,
    Order,
} from '~/containers/viewer/table-panel/DoseStatisticsTable';

type DoseStatisticsTableHeadCell = {
    disablePadding: boolean;
    id: keyof DoseStatisticsRow;
    label: string;
    numeric: boolean;
};

const headCells: readonly DoseStatisticsTableHeadCell[] = [
    {
        id: 'structure',
        numeric: false,
        disablePadding: false,
        label: 'Structure',
    },
    {
        id: 'minDoseGy',
        numeric: true,
        disablePadding: false,
        label: 'Min Dose (Gy)',
    },
    {
        id: 'maxDoseGy',
        numeric: true,
        disablePadding: false,
        label: 'Max Dose (Gy)',
    },
    {
        id: 'meanDoseGy',
        numeric: true,
        disablePadding: false,
        label: 'Mean Dose (Gy)',
    },
];

type DoseStatisticsTableHeadProps = {
    onRequestSort: (
        event: React.MouseEvent<unknown>,
        property: keyof DoseStatisticsRow
    ) => void;
    order: Order;
    orderBy: string;
};

export default function DoseStatisticsTableHead({
    order,
    orderBy,
    onRequestSort,
}: DoseStatisticsTableHeadProps) {
    const createSortHandler =
        (property: keyof DoseStatisticsRow) =>
        (event: React.MouseEvent<unknown>) =>
            onRequestSort(event, property);
    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align="left"
                        sx={(theme) => ({
                            position: 'relative',
                            pl:
                                headCell.id === 'structure'
                                    ? theme.spacing(4)
                                    : theme.spacing(1),
                        })}
                    >
                        {headCell.id === 'color' ? null : (
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={
                                    orderBy === headCell.id ? order : 'asc'
                                }
                                onClick={createSortHandler(headCell.id)}
                                sx={(theme) => ({
                                    color:
                                        orderBy === headCell.id
                                            ? `${theme.palette.primary.main}!important`
                                            : theme.palette.text.primary,
                                    '& .MuiTableSortLabel-icon': {
                                        fontSize: 12,
                                        color:
                                            orderBy === headCell.id
                                                ? `${theme.palette.primary.main}!important`
                                                : theme.palette.text.primary,
                                    },
                                })}
                            >
                                {headCell.label}
                            </TableSortLabel>
                        )}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}
